import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=db4948ea&"
import script from "./ConfirmPayment.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports